// extracted by mini-css-extract-plugin
export default {"popap":"styles_popap__yKubA","edit":"styles_edit__+nDjk","delete":"styles_delete__b9pWd"};